import Plyr from "plyr";
import 'plyr/dist/plyr.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class VideoPlayers {
    constructor() {

        this.playerInstances = [];
        this.init();

    }

    init() {
        const defaultOptions = {
            fullscreen: {
                enabled: true,
                iosNative: false
            },
            controls: [
                'play-large',
                'play',
                'progress',
                'current-time',
                'mute',
                'volume',
                'fullscreen'
            ],
            autoplay: false,
            storage: {
                enabled: false
            },
            youtube: {
                noCookie: true,
                rel: 0,
                modestbranding: 1,
                showinfo: 0
            }
        };

        const players = Array.from(document.querySelectorAll('.plyr-player'));

        players.map(player => {
            let playerInstance = null;
            const iframe = player.querySelector('iframe.plyr');
            const video = player.querySelector('video.plyr');
            const isAutoplay = player.closest('.autoplay') !== null;

            const options = {
                ...defaultOptions,
                muted: isAutoplay
            };

            if (iframe) {
                let src = iframe.getAttribute('src');
                if (src && src.includes('youtube.com/embed/')) {
                    const cleanSrc = src.split('?')[0];
                    const newParams = new URLSearchParams({
                        autoplay: isAutoplay ? 1 : 0,
                        mute: isAutoplay ? 1 : 0,
                        controls: 1,
                        modestbranding: 1,
                        rel: 0,
                        showinfo: 0,
                        enablejsapi: 1,
                        origin: window.location.origin
                    });

                    iframe.setAttribute('src', `${cleanSrc}?${newParams.toString()}`);
                }

                playerInstance = new Plyr(player, options);
                player.plyr = playerInstance;

                playerInstance.on('play', () => {
                    this.pauseOtherPlayers(playerInstance);
                });

                playerInstance.on('ready', () => {
                    ScrollTrigger.create({
                        trigger: player,
                        start: 'top 80%',
                        end: 'bottom 25%',
                        markers: false,
                        onEnter: () => {
                            if (isAutoplay) playerInstance.play();
                            this.pauseOtherPlayers(playerInstance);
                        },
                        onEnterBack: () => {
                            if (isAutoplay) playerInstance.play();
                            this.pauseOtherPlayers(playerInstance);
                        },
                        onLeave: () => playerInstance.pause(),
                        onLeaveBack: () => playerInstance.pause(),
                    });

                    ScrollTrigger.refresh();
                });
            }

            if (video) {
                playerInstance = new Plyr(video, options);
                player.plyr = playerInstance;

                playerInstance.on('play', () => {
                    this.pauseOtherPlayers(playerInstance);
                });

                ScrollTrigger.create({
                    trigger: player,
                    start: 'top 80%',
                    end: 'bottom 25%',
                    markers: false,
                    onEnter: () => {
                        if (isAutoplay) playerInstance.play();
                        this.pauseOtherPlayers(playerInstance);
                    },
                    onEnterBack: () => {
                        if (isAutoplay) playerInstance.play();
                        this.pauseOtherPlayers(playerInstance);
                    },
                    onLeave: () => playerInstance.pause(),
                    onLeaveBack: () => playerInstance.pause(),
                });

                ScrollTrigger.refresh();
            }

            if (playerInstance) {
                this.playerInstances.push(playerInstance);
            }

            return playerInstance;
        });

        setTimeout(() => {
            ScrollTrigger.refresh();
        }, 500);

    }

    pauseOtherPlayers(currentPlayer) {
        this.playerInstances.forEach(instance => {
            if (instance !== currentPlayer && instance.playing) {
                instance.pause();
            }
        });
    }

    pauseAllPlayers() {
        this.playerInstances.forEach(instance => {
            if (instance && instance.playing) {
                instance.pause();
            }
        });
    }
}
